import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ButtonTitle from "../../components/ButtonTitle";
import Activiti from "../../components/client/Activiti";
import SocialResponsibility from "../../components/client/SocialResponsibility";
import apiCustom from "../../utils/ApiCustom";
import BusinessForm from "../../components/client/BusinessForm";
import QRCode from "react-qr-code";
import EventPDFModal from "../../components/admin/EventPDFModal";
import ApiCustom from "../../utils/ApiCustom";
import { Link } from "react-router-dom";
import { HomeIcon } from "@heroicons/react/24/outline";

const DetailNoti = () => {
  const { slug1 } = useParams();
  const location = useLocation();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [commentLoading, setCommentLoading] = useState(false);
  const posts = useSelector((state) => state.posts.posts);
  const [scrolled, setScrolled] = useState(false);
  const [isRegistedEvent, setIsRegistedEvent] = useState(false);
  const [regisRollCallQRcode, setregisRollCallQRcode] = useState(null);
  const userId = localStorage.getItem("userId");
  const userEmail = localStorage.getItem("userEmail");
  const [isOpenPdf, setIsOpenPdf] = useState(false);
  const [eventData, setEventData] = useState(null);
  const [postData, setPostData] = useState(null);

  const handleOpenPdf = () => {
    setIsOpenPdf(true);
    ApiCustom.get("/event-show-by-post-id/" + postData.id)
      .then((res) => {
        console.log(res);
        setEventData(res.data.data[0]);
      })
      .catch((err) => console.log(err));
  };

  const handleClosePdf = () => {
    setIsOpenPdf(false);
  };

  useEffect(() => {
    const post = posts
      ?.filter((post) => post.status === "published")
      ?.find((post) => post.slug === slug1);
    setPostData(post);
    window.scrollTo(0, 0);
    const fetchArticle = async () => {
      try {
        if (!post) {
          setError("Post not found");
          setLoading(false);
          return;
        }
        const response = await apiCustom.get(`posts-public/${post.id}`);
        setArticle(response.data.data);
        setComments(response.data.data.comments || []);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    const checkEventRegisted = async () => {
      try {
        await apiCustom
          .get(
            `/eventRegistration-check-registed?email=${userEmail}&pid=${post.id}`
          )
          .then((res) => {
            setIsRegistedEvent(res?.data?.data?.isRegistered);
            setregisRollCallQRcode(res?.data?.rollCallQrCode);
          });
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchArticle();
    checkEventRegisted();
  }, [slug1, posts, isRegistedEvent]);

  const getRegisStatusFromBussinessForm = (isRegisted) => {
    setIsRegistedEvent(isRegisted);
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    setCommentLoading(true);
    try {
     

      // Assuming the API returns the newly created comment
      // const createdComment = response.data.data;

      // Update comments list
      // setComments([...comments, createdComment]);

      // Clear the comment input
      // setNewComment("");
    } catch (err) {
      console.error("Failed to submit comment:", err);
    } finally {
      setCommentLoading(false);
    }
  };

  if (loading) {
    return <div className="container mx-auto px-4">Loading...</div>;
  }

  if (error) {
    return <div className="container mx-auto px-4">Error: {error}</div>;
  }

  return (
    <div className="container mx-auto px-4">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2">
          <li className="inline-flex items-center">
            <Link to="/" className="inline-flex items-center hover:text-blue-600 font-medium">
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              Thông báo
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium">{article?.title}</span>
            </div>
          </li>
        </ol>
      </nav>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-3 mb-2">
        <div className="md:col-span-8 col-span-12 overflow-auto">
          <h1 className="text-3xl font-bold mb-4">{article?.title}</h1>
          <div className="text-gray-600 mb-6">
            {new Date(article?.createdAt).toLocaleDateString("vi-VN")}
          </div>
          <div className="flow-root">
            <div className="sun-editor-editable">
              <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={{ __html: article?.content }}
              />
            </div>
          </div>

          {/* Comments Section */}
          <div className="mt-8 hidden">
            <h2 className="text-2xl font-semibold mb-4">Bình luận</h2>
            {comments.length > 0 ? (
              <div className="space-y-4">
                {comments.map((comment) => (
                  <div key={comment.id} className="bg-gray-100 p-4 rounded-lg">
                    <div className="flex items-center mb-2">
                      <span className="font-medium text-gray-800">
                        {comment.user?.userFullName || "Ẩn danh"}
                      </span>
                      <span className="text-gray-500 text-sm ml-2">
                        {new Date(comment.createdAt).toLocaleString("vi-VN")}
                      </span>
                    </div>
                    <p className="text-gray-700">{comment.content}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500">Chưa có bình luận nào.</p>
            )}

            {/* Comment Submission Form */}
            <form
              onSubmit={handleCommentSubmit}
              className="mt-6 bg-gray-50 p-4 rounded-lg"
            >
              <textarea
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                placeholder="Nhập bình luận của bạn..."
                className="w-full p-2 border rounded-md mb-4 min-h-[100px]"
                required
              />
              <button
                type="submit"
                disabled={commentLoading}
                className={`
                  px-4 py-2 rounded-md text-white font-semibold
                  ${
                    commentLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                  }
                `}
              >
                {commentLoading ? "Đang gửi..." : "Gửi bình luận"}
              </button>
            </form>
          </div>
        </div>
        <div className="md:col-span-4 col-span-12">
          <div className={` top-0 ${scrolled ? "pt-16" : "pt-0"}`}>
            {/* <ButtonTitle title="Đăng ký tham gia" /> */}
            {userId && !loading && (
              <div className="my-2">
                <BusinessForm
                  noti={article}
                  isRegistedEvent={isRegistedEvent}
                  sendIsRegistedStatus={getRegisStatusFromBussinessForm}
                />

                {isRegistedEvent == true && (
                  <button
                    className="p-2 mt-4 border-green-400 border rounded-lg text-green-400 hover:border-green-600 hover:text-green-600 w-full"
                    onClick={handleOpenPdf}
                  >
                    XEM THIỆP MỜI
                  </button>
                )}
              </div>
            )}
          </div>
          <div className="flex items-center justify-center">
            {isRegistedEvent && regisRollCallQRcode && (
              <div className="col pt-4">
                <QRCode value={regisRollCallQRcode} />
                <p className="text-gray-500 text-center pt-4">
                  Mã QR điểm danh
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <ButtonTitle title="Hoạt động mới" />
      <Activiti />
      <ButtonTitle title="Đại hội" />
      <SocialResponsibility />
      <EventPDFModal
        isOpen={isOpenPdf}
        onClose={handleClosePdf}
        inviteQr={regisRollCallQRcode}
        data={eventData}
      />
    </div>
  );
};

export default DetailNoti;
